export const ACTIVE_EVENTS = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
export const INACTIVITY_DELAY = 1000 * 60 * 15;
export const REFRESH_TIME = 1000 * 60 * 10;
